import type { PreloadedQuery } from 'react-relay';
import CONNECTED_TO_ISSUE_AGG_DATA_QUERY, {
	type ConnectedToIssueAggQuery,
} from '@jira/issue__issue-view-app-provider/src/connected-to-issue-agg-query/__generated__/ConnectedToIssueAggQuery.graphql';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';

import type { RouteResource } from '@atlassian/react-resource-router';
import { getIssueKey } from '@atlassian/jira-router-resources-utils/src/utils/get-issue-key/index.tsx';

export const connectedToIssueAggDataResource: RouteResource<
	PreloadedQuery<ConnectedToIssueAggQuery, Record<string, unknown>>
> = createRelayResource<ConnectedToIssueAggQuery>({
	type: 'CONNECTED_TO_ISSUE_AGG_DATA',
	getQuery: ({ match }, { tenantContext }) => {
		const issueKey = getIssueKey(match);
		return {
			parameters: CONNECTED_TO_ISSUE_AGG_DATA_QUERY,
			variables: {
				cloudId: tenantContext?.cloudId || '',
				issueKey: issueKey || '',
			},
			options: { fetchPolicy: 'store-and-network' },
		};
	},
	isBrowserOnly: true,
});
